/** Thrown for any non-2xx API response. Carries the RFC 9457 problem body when the API sent one. */
export class ApiError extends Error {
    status;
    code;
    problem;
    constructor(status, problem) {
        super(problem?.detail ?? problem?.title ?? `Request failed with status ${status}`);
        this.name = 'ApiError';
        this.status = status;
        this.code = problem?.code ?? 'unknown_error';
        this.problem = problem;
    }
}
//# sourceMappingURL=errors.js.map